import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    ${media.mobileDevice`
        width:100%;
        position: fixed;
        top: 3.6rem;
        background-color:yellow;
        z-index: 2000;
        margin:0;
        padding:250px;
    `}
`;

export const DefaultContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-overflow: ellipsis;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    padding: 6px 0;
    /* padding-top: 10px;
    padding-bottom: 25px; */
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '5px')};
    width: 100%;
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    //font:15px Avenir Next World;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;

    ${media.mobileDevice`
        margin-bottom:15px ;
        /* padding-bottom: 30px; */
        padding: 0;
        // extra space removed b/w tissue service label and shipping details
        margin-top: 0px;
        // grey color applied from edge to edge
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
    `};
`;

export const BoxView = styled.div`
    border-radius: ${(props) => (props.bRadius ? props.bRadius : '3px')};
    margin-right: ${(props) => (props.mr ? props.mr : '2px')};
    margin-left: ${(props) => (props.ml ? props.ml : '2px')};
    margin-top: ${(props) => props.mTop};
    background-color: ${(props) => (props.bgColor ? props.bgColor : '#C2F1FD')};
    border: ${(props) =>
        props.bgBorder ? props.bgBorder : ' 1px solid #4b99ad'};
    height: ${(props) => (props.scrHeight ? props.scrHeight : ' 18px')};
    width: ${(props) => props.scrWidth ? props.scrWidth : '24px'};
    padding: ${(props) => (props.boxpadding ? props.boxpadding : '0px 4px')};
    display: flex;
    justify-content: ${(props) => (props.jContent ? props.jContent : 'center')};
    align-items: ${(props) => (props.aConetnt ? props.aConetnt : 'center')};
`;
